import { Component, Input } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';

import {
  CustomerSentiment,
  Insights,
  Interaction_Summary_List,
  InteractionSummary,
  InteractionTime,
} from '../report.constants';
import { InteractionPage, UIDataModel } from '../report.model';
import { FormatTimestampPipe } from '../../../pages/dashboard/tabular-view/pipes/format-timestamp-pipe.pipe';
import { DataViewTimestampFormatPipe } from '../../../pages/dashboard/tabular-view/pipes/data-view-timestamp-format.pipe';
import { SentimentIconPipe } from '../../../pipes/sentiment-icon.pipe';
import { SharedDataService } from '../../../services/shared-data.service';

@Component({
  selector: 'interaction-report',
  standalone: true,
  imports: [CommonModule, DataViewTimestampFormatPipe, FormatTimestampPipe, SentimentIconPipe],
  providers: [DatePipe, SharedDataService],
  templateUrl: './interaction-report.component.html',
  styleUrl: './interaction-report.component.scss',
})
export class InteractionReportComponent {
  @Input() interactionData: InteractionPage | { [key: string]: string | number | undefined } = {};
  @Input() index: number = 1;
  @Input() timezone: string = 'EST';

  tableRows: Array<UIDataModel> = Insights;
  details: Array<UIDataModel> = Interaction_Summary_List;
  interactionSummary = InteractionSummary;
  interactionTime = InteractionTime;
  customerSentiment = CustomerSentiment;

  get contactTimestamp(): string | null | undefined {
    const value = this.interactionData[this.interactionSummary.contactTimeStamp];
    if (value == null) return undefined;
    return typeof value === 'string' ? value : String(value);
  }

  ngOnInit(): void {}
}
